<template>
  <div class="stripe-modal-wrapper" @click='closeModal'>
    <div class='stripe-checkout'>
    <div class="title-wrap">
      <h1>Enter payment details</h1>
      <svg width="52" height="25" viewBox="0 0 52 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M24 22C24 23.1 23.1 24 22 24H3C1.9 24 1 23.1 1 22V8.99997C1 7.89997 1.9 6.99997 3 6.99997H22C23.1 6.99997 24 7.89997 24 8.99997V22Z" stroke="#969696" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9.40039 13L8.30039 15.4C8.00039 15.9 7.80039 16.5 7.60039 17C7.50039 16.5 7.50039 16 7.40039 15.4L7.20039 13H5.40039C5.10039 13 4.90039 13.2 4.90039 13.5C4.90039 13.8 5.10039 14 5.40039 14H6.20039L6.70039 18H8.00039L10.6004 13H9.40039ZM11.2004 13L10.2004 18H11.3004L12.2004 13H11.2004ZM14.6004 15C14.2004 14.8 13.9004 14.6 13.9004 14.3C13.9004 14 14.2004 13.8 14.7004 13.8C15.1004 13.8 15.5004 13.9 15.6004 14L15.9004 13.1C15.7004 13 15.3004 12.8 14.7004 12.8C13.6004 12.8 12.7004 13.4 12.7004 14.4C12.7004 15.1 13.2004 15.5 13.7004 15.7C14.2004 15.9 14.4004 16.1 14.4004 16.4C14.4004 16.8 14.0004 17 13.6004 17C13.1004 17 12.7004 16.9 12.4004 16.7L12.0004 17.6C12.2004 17.8 12.7004 18 13.4004 18C14.5004 18 15.5004 17.4 15.5004 16.3C15.6004 15.8 15.2004 15.4 14.6004 15ZM19.6004 13H18.2004L15.7004 18H16.8004L17.5004 16.5H19.0004L19.1004 18H20.2004L19.6004 13ZM17.8004 16L18.3004 15C18.4004 14.7 18.6004 14 18.7004 14C18.7004 14 18.8004 14.7 18.8004 15L18.9004 16H17.8004Z" fill="#969696"/>
        <path d="M42.5 16C42.7761 16 43 15.7761 43 15.5C43 15.2239 42.7761 15 42.5 15C42.2239 15 42 15.2239 42 15.5C42 15.7761 42.2239 16 42.5 16Z" stroke="#969696" stroke-miterlimit="10"/>
        <path d="M42.5 16V19" stroke="#969696" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M34 10H51V24H34V10ZM37 6.5C37 3.5 39.5 1 42.5 1C45.5 1 48 3.5 48 6.5V10H37V6.5Z" stroke="#969696" stroke-miterlimit="10"/>
      </svg>
    </div>
    <div class="supported-payments">
      <div class="supported-cards">
        <svg width="41" height="27" viewBox="0 0 41 27" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="40.5" height="27" rx="4" fill="#2A2A6C"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M25.6066 14.9096C25.6117 13.6231 24.5507 13.0674 23.7273 12.6362C23.206 12.3632 22.78 12.1401 22.78 11.813C22.78 11.5346 23.05 11.2392 23.6238 11.1633C24.3066 11.0957 24.995 11.2153 25.615 11.5092L25.9694 9.82174C25.3649 9.59508 24.7249 9.47793 24.0794 9.47581C22.0881 9.47581 20.7044 10.5389 20.7044 12.0577C20.7044 13.1799 21.7084 13.8042 22.4678 14.1755C23.2272 14.5467 23.5225 14.8083 23.5141 15.1458C23.5141 15.6689 22.8897 15.9052 22.3075 15.9136C21.5894 15.9229 20.8807 15.7486 20.2488 15.4074L19.8859 17.0949C20.601 17.374 21.3627 17.5143 22.1303 17.5083C24.2481 17.5083 25.6403 16.4621 25.6488 14.8421L25.6066 14.9096ZM20.131 9.61095L18.4435 17.4156H16.4185L18.106 9.61095H20.131ZM28.6185 14.6732L29.6817 11.7454L30.2976 14.6732H28.6185ZM32.7441 17.4399H30.871L30.6263 16.2756H28.0866L27.6731 17.4399H25.5469L28.576 10.209C28.7156 9.86496 29.0484 9.63865 29.4197 9.63525H31.1072L32.7441 17.4399ZM14.0135 17.3919L17.2872 9.58717H15.0935L12.9925 14.8944L12.1488 10.3803C12.0741 9.92159 11.677 9.58528 11.2122 9.58717H7.77816L7.72754 9.81498C8.41632 9.94974 9.08536 10.1709 9.71879 10.4731C9.98858 10.6 10.1714 10.8598 10.1997 11.1565L11.8113 17.3919H14.0135Z" fill="white"/>
        </svg>
        <svg width="41" height="27" viewBox="0 0 41 27" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="40.5" height="27" rx="4" fill="#F2F0EC"/>
          <g opacity="0.01">
          <rect x="3.92383" y="2.69996" width="32.6616" height="21.6" fill="white"/>
          </g>
          <rect x="15.9473" y="6.46301" width="8.61469" height="14.0738" fill="#F26122"/>
          <path d="M16.8748 13.4999C16.8605 10.7607 18.1047 8.1666 20.2498 6.46303C16.5797 3.57681 11.3077 3.99592 8.13966 7.42575C4.97167 10.8556 4.97167 16.1442 8.13966 19.5741C11.3077 23.0039 16.5797 23.423 20.2498 20.5368C18.1047 18.8332 16.8605 16.2391 16.8748 13.4999Z" fill="#EA1D25"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M33.868 18.7564V19.0433H33.8173V18.7564H33.6992V18.6974H33.9945V18.7564H33.868ZM34.4426 18.6974V19.0433H34.3835V18.7818L34.2907 19.0096H34.2232L34.1219 18.7818V19.0433H34.0629V18.6974H34.1473L34.2569 18.9421L34.3582 18.6974H34.4426Z" fill="#F69E1E"/>
          <path d="M34.7288 13.4999C34.7265 16.925 32.7703 20.0486 29.6898 21.5458C26.6092 23.043 22.9445 22.6513 20.25 20.5368C24.1313 17.4807 24.8034 11.8583 21.7519 7.97338C21.3144 7.41083 20.8101 6.90365 20.25 6.46307C22.9445 4.34863 26.6092 3.95691 29.6898 5.45409C32.7703 6.95126 34.7265 10.0749 34.7288 13.4999Z" fill="#F69E1E"/>
        </svg>
        <svg width="41" height="27" viewBox="0 0 41 27" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.000976562" width="40.4997" height="26.9998" rx="4" fill="white"/>
          <path d="M7.49245 15.1032V21.9881H14.4618L15.1874 20.9588L15.8961 21.9881H20.1571V20.4356H20.6296C21.0585 20.4394 21.4854 20.3768 21.8952 20.25V21.9881H24.7892V20.7563L25.768 21.9881H38.9472C39.489 21.9976 40.022 21.8512 40.4829 21.5663V24.4687C40.0968 25.964 38.745 27.0065 37.2007 27H3.37498C1.51103 27 0 25.4889 0 23.625V12.9938H1.92374L2.3203 11.9644H3.26529L3.65341 12.9938H19.1277V11.7619L20.1064 12.9938H24.1648V12.3694C24.76 12.7931 25.4764 13.0121 26.2067 12.9938H28.6283L29.0164 11.9644H29.9614L30.3748 12.9938H34.5092V11.6607L35.3529 12.9938H38.2048V6.10886H35.1757V7.50947L34.2729 6.10886H31.6235V7.88072L30.7798 6.10886H26.2742C25.512 6.08677 24.7659 6.33147 24.1648 6.80073V6.10886H9.28119L8.77494 7.59385L8.2687 6.07511H4.89372V7.84697L4.1006 6.07511H1.34999L0 9.28133V3.37512C0 1.51117 1.51103 0.000145754 3.37498 0.000145754H37.2007C38.7513 -0.0141872 40.1121 1.02994 40.4997 2.53138V15.1032H15.913L15.1874 16.1157L14.4787 15.1032H7.49245Z" fill="#296DB6"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M17.989 16.2007H20.6131V16.1669C21.05 16.1302 21.4817 16.283 21.7981 16.5866C22.1146 16.8901 22.2853 17.315 22.2668 17.7531C22.2776 18.1965 22.1003 18.6237 21.7788 18.9292C21.4573 19.2346 21.0215 19.3898 20.5793 19.3563H19.1449V20.9256H17.989V16.2007ZM15.8644 18.5623L17.7712 16.1998H16.3706L15.1894 17.668L14.0166 16.1661H12.5822L14.5144 18.5623L12.6581 20.9248H14.0419L15.1894 19.4061L16.3369 20.9417H17.7881L15.8644 18.5623ZM12.412 17.1786V16.1661H8.58984V20.9248H12.412V19.9123H9.73734V19.0686H12.3614V18.0392H9.73734V17.1955L12.412 17.1786ZM20.5128 18.378H19.1459V17.1799H20.5128C20.8343 17.1799 21.095 17.4406 21.095 17.7621C21.095 18.0836 20.8343 18.3443 20.5128 18.3443V18.378ZM27.1441 17.5418C27.2419 18.3713 26.6488 19.123 25.8194 19.2209L27.4141 20.9252H25.9713L24.5538 19.2378H24.0306V20.9252H22.8832V16.2172H25.465C26.2945 16.1193 27.0462 16.7124 27.1441 17.5418ZM25.3653 18.2766H24.0322V17.1797H25.3653C25.5153 17.1602 25.6664 17.2066 25.7797 17.3069C25.8929 17.4072 25.9572 17.5516 25.9559 17.7029C25.9601 17.8551 25.8967 18.0013 25.7827 18.1023C25.6687 18.2032 25.5159 18.2485 25.3653 18.226V18.2766ZM31.5241 16.2182V17.2307L28.8495 17.197V18.0407H31.4566V19.0701H28.8495V19.9138H31.5241V20.9263H27.6851V16.2182H31.5241ZM34.7058 18.0726H33.6005C33.4297 18.1069 33.255 18.0348 33.1581 17.89C33.0612 17.7452 33.0612 17.5562 33.1581 17.4114C33.255 17.2666 33.4297 17.1945 33.6005 17.2288H35.6508L36.1064 16.2164H33.6343C33.2136 16.1676 32.7924 16.3029 32.4788 16.5874C32.1652 16.8719 31.9897 17.278 31.9974 17.7013C31.9718 18.0953 32.1232 18.4802 32.4104 18.751C32.6976 19.0219 33.0906 19.1506 33.4824 19.102H34.5961C34.767 19.0676 34.9416 19.1397 35.0385 19.2845C35.1355 19.4293 35.1355 19.6183 35.0385 19.7631C34.9416 19.908 34.767 19.98 34.5961 19.9457H32.1324V20.9582H34.5961C35.0213 20.993 35.4408 20.8421 35.7465 20.5445C36.0521 20.2469 36.2142 19.8317 36.1908 19.4057C36.2121 19.0157 36.058 18.6366 35.7706 18.3721C35.4833 18.1076 35.0927 17.9853 34.7058 18.0388V18.0726ZM40.048 17.229H37.9977L37.9724 17.1953C37.8015 17.1609 37.6269 17.233 37.53 17.3778C37.433 17.5227 37.433 17.7116 37.53 17.8564C37.6269 18.0013 37.8015 18.0733 37.9724 18.039H39.1199C39.7035 17.979 40.2604 18.2982 40.5036 18.8321V19.9627C40.2713 20.606 39.6317 21.0092 38.9511 20.9415H36.5296V19.929H38.968C39.1388 19.9633 39.3135 19.8913 39.4104 19.7464C39.5073 19.6016 39.5073 19.4126 39.4104 19.2678C39.3135 19.123 39.1388 19.0509 38.968 19.0853H37.8796C37.4878 19.1339 37.0947 19.0052 36.8075 18.7343C36.5204 18.4634 36.3689 18.0786 36.3946 17.6846C36.3869 17.2613 36.5624 16.8552 36.876 16.5707C37.1896 16.2862 37.6108 16.1509 38.0314 16.1996H40.5036L40.048 17.229Z" fill="#296DB6"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M21.4719 8.6731C21.4904 9.43372 20.9279 10.0839 20.1725 10.175L21.7588 11.9299H20.3244L18.9069 10.2425H18.3838V11.9299H17.211V7.17123H19.7844C20.2144 7.11484 20.6476 7.2481 20.9715 7.53639C21.2954 7.82468 21.478 8.23951 21.4719 8.6731ZM3.56904 7.17034H2.06717L0 11.9291H1.24874L1.68749 10.9672H3.90654L4.31153 11.9628H5.6109L3.56904 7.17034ZM2.00802 10.0074L2.47208 8.89361L2.77583 8.15111L3.07958 8.89361L3.5352 10.0074H2.00802ZM8.94411 9.92332L9.87223 7.17272H11.72V11.9314H10.6063V8.80958V8.08396L10.3869 8.80958L9.2816 11.9314H8.26911L7.18912 8.80958L6.95287 8.08396V8.80958V11.9314H5.83069V7.17272H7.69536L8.64036 9.92332L8.79223 10.4464L8.94411 9.92332ZM16.4521 8.18521V7.17272H12.6553V11.9314H16.4521V10.9189H13.7775V10.0752H16.3846V9.04583H13.7775V8.20208L16.4521 8.18521ZM19.7168 9.229H18.3836V8.18276H19.7168C19.8662 8.16604 20.0157 8.2134 20.1283 8.3131C20.2409 8.4128 20.3059 8.55551 20.3074 8.70588C20.3116 8.85808 20.2481 9.00431 20.1341 9.10526C20.0202 9.20621 19.8673 9.25152 19.7168 9.229ZM22.0275 11.9314V7.17272H23.1835V11.9314H22.0275ZM26.247 8.19929H27.4873V7.16992H26.1542C25.5266 7.13025 24.9131 7.3671 24.475 7.81818C24.0369 8.26925 23.8181 8.8894 23.8761 9.51553V9.58303C23.8056 10.2002 24.0107 10.8171 24.4367 11.2691C24.8628 11.7212 25.4664 11.9625 26.0867 11.9286H26.1542L26.6182 10.9161H26.2386C25.8884 10.9341 25.5483 10.7956 25.3104 10.5381C25.0724 10.2806 24.9611 9.93069 25.0067 9.58303V9.51553C24.9666 9.17058 25.0803 8.82546 25.3176 8.57191C25.5549 8.31836 25.8917 8.18208 26.2386 8.19929H26.247ZM28.7634 7.17272H30.2822L32.3156 11.9652H31.0162L30.6112 10.9696H28.3584L27.9534 11.9314H26.7216L28.7634 7.17272ZM28.7296 10.0074L29.1683 8.89361L29.4721 8.15111L29.7589 8.89361L30.2146 10.0074H28.7296ZM35.9525 9.70395V7.17272H37.1254V11.9314H35.7332L33.9697 9.24833L33.666 8.72521V9.28208V11.9652H32.5354V7.20647H33.9444L35.6319 9.7377L35.9525 10.2777V9.70395Z" fill="#296DB6"/>
        </svg>
      </div>
    </div>
    <!-- <input type="number" id="card-number" placeholder="Card number"/>
    <div class="card-data-frame">
      <input type="number" id="card-expiry-data" placeholder="MM / YY"/>
      <input type="number" id="card-cvc" placeholder="CVC"/>
    </div> -->
    <input type="text" placeholder="Card Holder Name" class="card-holder-name"/>
    <div class="checkout-input" id="card-number" placeholder="Card number"></div>
    <div class="checkout-mini-wrapper">
      <div class="checkout-input" id="card-expiry" placeholder="MM / YY"></div>
      <div class="checkout-input" id="card-cvc" placeholder="CVC"></div>
    </div>
    <p>Your plan will renew at the end of your billing period. </p> 
    <p>At any time prior, you can turn this off via your account.</p> 
    <p>All purchases and renewals are non-refundable.</p>
    <div class="button-action-wrap">
      <button type="button" class="orange-btn cancel">Cancel</button>
      <button type="button" class="orange-btn" @click='addNewCard'>Add Payment Method</button>
    </div>
  </div>
  </div>
</template>

<script>
import { StripeElementCard } from '@vue-stripe/vue-stripe';
import {axiosClient} from "@/axios-client";

export default {
  components: {
    StripeElementCard
  },

  data() {
    this.publishableKey = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY;
    return {
      loading: false,
      sessionId: 'session-id',
      lineItems: [
        {
          price: process.env.VUE_APP_FOUNDING_MEMBERSHIP_PRICE_ID, // The id of the recurring price you created in your Stripe dashboard
          quantity: 1,
        },
      ],
      successURL: process.env.VUE_APP_PAYMENT_SUCCESS_URL,
      cancelURL: process.env.VUE_APP_PAYMENT_CANCELLATION_URL,
      currentUser: {},
      stripe: null,
      clientSecret: null,
      subscriptionId: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null
    };
  },

  created() {
       axiosClient.get('/v1/stripe/setup-intent')
        .then((res) => this.clientSecret = res.data.clientSecret);
  },

  mounted() {
    const style = {
      base: {
        color: 'black',
        fontFamily: '"Gotham", Gotham, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#676868',
        },
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a',
      },
    };

    this.stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY)
    var stripeElements = this.stripe.elements();

    this.cardNumber = stripeElements.create('cardNumber', {style});
    this.cardNumber.mount('#card-number');
    this.cardExpiry = stripeElements.create('cardExpiry', {style});
    this.cardExpiry.mount('#card-expiry');
    this.cardCvc = stripeElements.create('cardCvc', {style});
    this.cardCvc.mount('#card-cvc');
  },

  methods: {
    closeModal(e) {
      let target = e.target.className;
      
      if(target.includes('stripe-modal-wrapper') || target.includes('cancel')) {
        document.querySelector('.stripe-modal-wrapper').style.opacity = '0';
        document.querySelector('.stripe-modal-wrapper').style.zIndex = '-999';
        document.querySelector('body').style.overflow = 'auto';
      }
    },

    addNewCard() {
      this.$store.commit('resultsAreLoading');
      document.querySelector('body').style.overflow = 'auto';
      let cardHolderName = document.querySelector('.card-holder-name').value;

      this.stripe.confirmCardSetup(this.clientSecret, {
        payment_method: {
          card: this.cardNumber,
          billing_details: {
            name: cardHolderName,
          },
      },
      }).then((res) => location.reload());
    },
  }
}
</script>

<style lang="scss">
  .stripe-modal-wrapper {
    width: 100%;
    height: calc(100% + 91px);
    position: fixed;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: -999;
    display: flex;
    justify-content: center;
    align-items: center;

    .stripe-checkout {
      width: 540px;
      background: #fff;
      padding: 55px 65px;

      .title-wrap {
        display: flex;
        justify-content: space-between;

        h1 {
          font-size: 26px;
          line-height: 25px;
          font-family: "Gotham-Medium", sans-serif;
          margin: 0;
        }
      }

      .supported-payments {
        margin: 45px 0;

        .supported-cards {
          svg {
            margin-right: 7.5px;
          }
        }
      }

      .checkout-input {
      border: 1px solid #CDCDCD;
      border-radius: 5px;
      padding: 16px 20px;
    }
    .card-data-frame {
      display: flex;
      justify-content: space-between;
      input {
        width: 48%;
      }
    }
    .checkout-mini-wrapper {
      display: flex;
      justify-content: space-between;
      margin: 20px 0 10px 0;

      .checkout-input {
        width: 48%;
      }
    }

      input {
        width: 100%;
        padding: 15px 20px;
        border: 1px solid #CDCDCD;
        border-radius: 5px;
        margin-bottom: 20px;

        &:focus {
          outline: none;

          &::placeholder {
            color: transparent;
          }
        }
      }

      input[type="number"] {
                appearance: none;
        -webkit-appearance: none;
      }

      p {
        font-size: 14px;
        line-height: 22px;
        color: #676868;
        margin: 0;
      }

      .button-action-wrap {
        display: flex;
        justify-content: space-between;
        margin-top: 35px;

        button {
          width: 48%;
          border: none;
          border-radius: 5px;
          font-size: 16px;
          line-height: 15px;

          &.cancel {
            background: #ebebeb;
            font-family: "Gotham-Book";
            color: #333;
          }

          &:focus {
            outline: none;
          }
        }
      }
    }
  }
</style>